import React, { useState, useEffect } from 'react';
import { Grid, Box, Tabs, Tab, Card } from '@mui/material';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../../../components/Layout/PageHeaderLayout';
import VideoUpload from './VideoUpload';
import VideoList from './VideoList';

const VideoPage = () => {
    const menuDispatch = useDispatch();
    const [currentTab, setCurrentTab] = useState('whatsapp');
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media-video'
        });
    }, [menuDispatch]);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const handleUploadSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={currentTab} 
                        onChange={handleTabChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                        sx={{ p: 0, minHeight: '40px' }}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                    <Tab label="WhatsApp" value="whatsapp" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    {/* <Tab label="All Videos" value="all" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} /> */}
                    {/* <Tab value="three" label="Item Three" /> */}
                    </Tabs>
                </Box>
            </Card>
            <Grid container spacing={2} sx={{}}>
                {/* Upload Section */}
                <Grid item xs={12} md={5}>
                    <VideoUpload onUploadSuccess={handleUploadSuccess} currentTab={currentTab} />
                </Grid>

                {/* List Section */}
                <Grid item xs={12} md={7}>
                    <VideoList refreshTrigger={refreshTrigger} currentTab={currentTab} />
                </Grid>
            </Grid>
        </>
    );
};

export default VideoPage;
